import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=3406a5cc"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports